export { default as GDMDrawer } from './GDMDrawer';

export type { GDMDrawerComponent, GDMDrawerProps } from './GDMDrawer.type';
